import DataStorage from '../_utils/DataStorage';

const CARDS_PER_PAGE = 9;
const TRANSITION_DURATION = 1000;

export default class PressReleases {


	// Constructor
	constructor(element) {

		var i;
		var l;


		////////////////////

		// Get Elements

		this.categorySelect = element.querySelector('.section-press-releases--sectors select');
		this.categorySelectText = element.querySelector('.section-press-releases--sectors span');

		this.typeSelect = element.querySelector('.section-press-releases--types select');
		this.typeSelectText = element.querySelector('.section-press-releases--types span');

		this.categorySelect.addEventListener('change', this.categorySelectChange.bind(this));
		this.typeSelect.addEventListener('change', this.typeSelectChange.bind(this));

		this.updateCards = this.updateCards.bind(this);
		this.cardContainer = element.querySelector('.section-press-releases--cards');
		this.cards = Array.prototype.slice.call(element.querySelectorAll('.card-press-release'), 0);

		this.noResults = element.querySelector('.section-press-releases--no-results');

		this.moreButtonContainer = element.querySelector('.section-press-releases--button');
		this.moreIsEnabled = false;
		this.visibleCards = CARDS_PER_PAGE;
		if (this.moreButtonContainer) {
			this.moreIsEnabled = true;
			this.moreButtonContainer.querySelector('button').addEventListener('click', this.moreButtonClick.bind(this));
		}

		////////////////////

		// Get Select Options

		this.categoryValues = {};
		if (this.categorySelect) {
			for (i=0, l=this.categorySelect.options.length; i<l; i++) {
				this.categoryValues[ this.categorySelect.options[i].value ] = this.categorySelect.options[i].text;
			}
		}

		this.typeValues = {};
		if (this.typeSelect) {
			for (i=0, l=this.typeSelect.options.length; i<l; i++) {
				this.typeValues[ this.typeSelect.options[i].value ] = this.typeSelect.options[i].text;
			}
		}


		////////////////////

		// Get Initial Values

		this.valCat = 'all';
		this.valType = 'all';
		this.valGoTo = null;

		const urlParams = new URLSearchParams(window.location.search);
		if (urlParams) {
			const prevGoTo = urlParams.get('goto');
			if (prevGoTo) {
				this.valGoTo = prevGoTo;
			}
		}

		const prevCat = DataStorage.getSessionItem('resource-list-category');
		if (prevCat && this.categoryValues[prevCat]) {
			this.valCat = prevCat;
		}
		
		const prevType = DataStorage.getSessionItem('resource-list-type');
		if (prevType && this.typeValues[prevType]) {
			this.valType = prevType;
		}

		const visibleCards = DataStorage.getSessionItem('resource-list-cards');
		if (visibleCards) {
			this.visibleCards = visibleCards;
		}

		////////////////////

		// Misc Vars

		this.isFirst = true;
		this.timer = null;

		////////////////////

		// Initial Update

		this.updateFields();
	}


	// Update
	updateFields(forceUpdate) {

		clearTimeout(this.timer);

		if (this.moreIsEnabled === false) {
			this.visibleCards = this.cards.length;
		}

		this.categorySelect.value = this.valCat;
		this.categorySelectText.innerHTML = this.categoryValues[this.valCat];
		this.typeSelect.value = this.valType;
		this.typeSelectText.innerHTML = this.typeValues[this.valType];

		DataStorage.setSessionItem('resource-list-category', this.valCat);
		DataStorage.setSessionItem('resource-list-type', this.valType);
		DataStorage.setSessionItem('resource-list-cards', this.visibleCards);

		if (forceUpdate || this.isFirst) {
			this.isFirst = false;
			this.updateCards();
		} else {
			this.cardContainer.classList.add('fade-out');
			this.noResults.classList.add('fade-out');
			this.timer = setTimeout(this.updateCards, TRANSITION_DURATION);
		}

	}
	updateCards(loadMore) {
		clearTimeout(this.timer);

		const container = this.cardContainer;
		const cat = this.valCat;
		const type = this.valType;

		let totalCards = 0;
		let visibleCards = this.visibleCards;

		if (loadMore !== true) {
			this.cards.forEach(function(card){
				if (card.parentNode) {
					card.parentNode.removeChild(card);
				}
			});
		}

		this.cards.forEach(function(card){
			const cats = card.getAttribute('data-categories').split('|');
			const catMatch = (cat === 'all' || cats.indexOf(cat) > -1) ? true : false;

			const types = card.getAttribute('data-type');
			const typeMatch = (type === 'all' || types === type) ? true : false;

			if (catMatch && typeMatch) {
				if (totalCards < visibleCards) {
					if (!card.parentNode) {
						container.appendChild(card);
					}
				}
				totalCards += 1;
			}
		});

		if (totalCards === 0) {
			this.noResults.classList.add('show');
		} else {
			this.noResults.classList.remove('show');
		}

		if (this.moreButtonContainer) {
			if (visibleCards < totalCards) {
				this.moreButtonContainer.classList.remove('hide');
			} else {
				this.moreButtonContainer.classList.add('hide');
			}
		}

		window.dispatchEvent(new Event('resize'));
		this.cardContainer.classList.remove('fade-out');
		this.noResults.classList.remove('fade-out');

		if (this.valGoTo) {
			const scrollTo = document.getElementById('press-release-' + this.valGoTo);
			if (scrollTo) {
				const y = scrollTo.getBoundingClientRect().top + window.pageYOffset - 100;
				window.scroll(0, y);
			}
		}
		this.valGoTo = null;

	}


	// Event Handlers
	categorySelectChange(event) {
		this.valCat = event.currentTarget.value;
		this.visibleCards = CARDS_PER_PAGE;
		this.updateFields();
	}
	typeSelectChange(event) {
		this.valType = event.currentTarget.value;
		this.visibleCards = CARDS_PER_PAGE;
		this.updateFields();
	}
	moreButtonClick(event) {
		event.preventDefault();
		event.currentTarget.blur()
		this.visibleCards += CARDS_PER_PAGE;
		this.updateFields()
		this.updateCards(true);
	}


}
